<kendo-dropdownlist
[data]="data"
(valueChange)="onChange($event)"
[value]="selectedValue"
>
</kendo-dropdownlist>
<button kendoButton (click)="this.onChange(null)" themeColor="primary">Clear</button>